import { NgClass } from '@angular/common';
import { Component, OnInit, computed, inject, signal } from '@angular/core';
import { UserRole } from 'src/app/models/security/user-role-enum';
import { DropdownOption } from 'src/app/models/shared/dropdown-option';
import { AuthService } from 'src/app/services/auth.service';
import { DropdownService } from 'src/app/services/dropdown.service';

@Component({
  selector: 'app-available-services',
  imports: [NgClass],
  templateUrl: './available-services.component.html',
  styleUrl: './available-services.component.css'
})
export class AvailableServicesComponent implements OnInit {
  private readonly dropdownService = inject(DropdownService);
  private readonly authService = inject(AuthService);

  availableService = signal<DropdownOption[]>([]);

  userRole = UserRole;
  companies = computed(() => this.availableService().filter(s => s.relatedId == +this.userRole.Company));
  candidates = computed(() => this.availableService().filter(s => s.relatedId == +this.userRole.Member));

  currentRole: string | null = '';

  ngOnInit(): void {
    this.currentRole = this.authService.getUserRoleId();
    this.dropdownService.GetOptions('AvailableServices').subscribe({
      next: res => this.availableService.set(res)
    });
  }
}